(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
	document.addEventListener('click', function (e) {
		var opener = e.target.closest('[data-ab-terms-open]');
		if (opener) {
			var dlg = document.getElementById('ab-terms-' + opener.getAttribute('data-ab-terms-open'));
			if (dlg && typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
			return;
		}
		var closer = e.target.closest('[data-ab-terms-close]');
		if (closer) {
			var d = closer.closest('dialog');
			if (d) d.close();
			return;
		}
		if (e.target.matches && e.target.matches('dialog.ab-terms')) e.target.close();
	});

  } catch(e) { console.error(e); }
})();
})();
